'use strict';

//export const ARISTOMETRIX_HOST = 'http://aristometrix.ariston.com:3001/';
export const ARISTOMETRIX_HOST = 'https://aristometrix.ariston.com:3443/';
export const ARISTOMETRIX_LOCAL_DATA_HOST = 'assets/data/';
export const ARISTOMETRIX_LOCAL_IMG_HOST = 'assets/img/models/';
